import { render, staticRenderFns } from "./PartiesList.vue?vue&type=template&id=7bbbe190"
import script from "./PartiesList.vue?vue&type=script&lang=js"
export * from "./PartiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports